class ContactForm {
  constructor() {
    this.root = document.querySelector('.p-contact .wpcf7-form') || document.querySelector('.c-contact-form');
    if (!this.root) return;

    this.form = this.root.closest('form') || this.root;
    this.careerValue = (window.arkContact && window.arkContact.careerCategory) || 'キャリア採用';
    this.applyQueryCategory();
    this.bindCategory();
    this.bindFileFields();
    this.syncMode();
  }

  bindFileFields() {
    this.form.querySelectorAll('.c-contact-form__field--file').forEach((field) => {
      const input = field.querySelector('input[type="file"]');
      const nameEl = field.querySelector('.js-contact-file-name');
      if (!input || !nameEl) return;

      const syncName = () => {
        nameEl.textContent = input.files && input.files[0] ? input.files[0].name : '';
      };
      input.addEventListener('change', syncName);
      syncName();
    });
  }

  applyQueryCategory() {
    const params = new URLSearchParams(window.location.search);
    const category = params.get('category');
    if (!category) return;
    const target = this.form.querySelector(`input[name="inquiry-category"][value="${CSS.escape(category)}"]`);
    if (target) {
      target.checked = true;
    }
  }

  getCategory() {
    const checked = this.form.querySelector('input[name="inquiry-category"]:checked');
    return checked ? checked.value : '';
  }

  isCareer() {
    return this.getCategory() === this.careerValue;
  }

  syncMode() {
    const career = this.isCareer();
    this.form.querySelectorAll('.js-contact-fields--general').forEach((el) => {
      el.hidden = career;
      el.querySelectorAll('input, textarea, select').forEach((input) => {
        if (career) {
          input.setAttribute('data-ark-disabled', '1');
        } else {
          input.removeAttribute('data-ark-disabled');
        }
      });
    });
    this.form.querySelectorAll('.js-contact-fields--career').forEach((el) => {
      el.hidden = !career;
      el.querySelectorAll('input, textarea, select').forEach((input) => {
        if (!career) {
          input.setAttribute('data-ark-disabled', '1');
        } else {
          input.removeAttribute('data-ark-disabled');
        }
      });
    });
  }

  bindCategory() {
    this.form.querySelectorAll('input[name="inquiry-category"]').forEach((input) => {
      input.addEventListener('change', () => this.syncMode());
    });
  }
}
